// Multi-Cart UI Controller
class MultiCartUI {
  constructor() {
    this.manager = window.multiCartManager;
    this.panel = document.getElementById('multiCartPanel');
    this.toggle = document.getElementById('multiCartToggle');
    this.cartList = document.getElementById('cartList');
    this.createBtn = document.getElementById('createCartBtn');
    this.modal = document.getElementById('modalOverlay');
    this.modalTitle = document.getElementById('modalTitle');
    this.modalInput = document.getElementById('cartNameInput');
    this.modalConfirm = document.getElementById('modalConfirm');
    this.modalCancel = document.getElementById('modalCancel');
    this.cartCount = document.getElementById('cartCount');
    
    this.currentAction = null;
    this.currentCartId = null;
    
    this.init();
  }

  init() {
    // Event listeners
    this.toggle.addEventListener('click', () => this.togglePanel());
    this.createBtn.addEventListener('click', () => this.showCreateModal());
    this.modalCancel.addEventListener('click', () => this.hideModal());
    this.modalConfirm.addEventListener('click', () => this.handleModalConfirm());
    
    // Close panel when clicking outside
    document.addEventListener('click', (e) => {
      if (!e.target.closest('.multi-cart-widget')) {
        this.panel.classList.remove('active');
      }
    });

    // Render carts
    this.renderCarts();
    this.updateCartCount();
  }

  togglePanel() {
    this.panel.classList.toggle('active');
    this.renderCarts();
  }

  renderCarts() {
    const carts = this.manager.getAllCarts();
    const currentCartId = this.manager.getCurrentCartId();
    
    if (Object.keys(carts).length === 0) {
      this.cartList.innerHTML = `
        <div class="empty-state">
          <div class="empty-state-icon">🛒</div>
          <p>No carts yet. Create your first cart!</p>
        </div>
      `;
      return;
    }

    this.cartList.innerHTML = Object.values(carts).map(cart => {
      const isActive = cart.id === currentCartId;
      const itemCount = this.manager.getCartItemCount(cart.id);
      const createdDate = new Date(cart.createdAt).toLocaleDateString();
      
      return `
        <div class="cart-item ${isActive ? 'active' : ''}" data-cart-id="${cart.id}">
          <div class="cart-item-header">
            <div class="cart-item-name">${cart.name}</div>
          </div>
          <div class="cart-item-info">
            <span>📦 ${itemCount} items</span>
            <span>📅 ${createdDate}</span>
          </div>
          ${!isActive ? `
            <div class="cart-item-actions">
              <button class="cart-action-btn switch-btn" data-cart-id="${cart.id}">
                Switch to this cart
              </button>
              <button class="cart-action-btn rename-btn" data-cart-id="${cart.id}">
                Rename
              </button>
              <button class="cart-action-btn danger delete-btn" data-cart-id="${cart.id}">
                Delete
              </button>
            </div>
          ` : ''}
        </div>
      `;
    }).join('');

    // Add event listeners to action buttons
    this.attachCartActionListeners();
  }

  attachCartActionListeners() {
    // Switch cart
    document.querySelectorAll('.switch-btn').forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.stopPropagation();
        const cartId = btn.dataset.cartId;
        this.switchCart(cartId);
      });
    });

    // Rename cart
    document.querySelectorAll('.rename-btn').forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.stopPropagation();
        const cartId = btn.dataset.cartId;
        this.showRenameModal(cartId);
      });
    });

    // Delete cart
    document.querySelectorAll('.delete-btn').forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.stopPropagation();
        const cartId = btn.dataset.cartId;
        this.deleteCart(cartId);
      });
    });
  }

  async switchCart(cartId) {
    const cart = this.manager.getCart(cartId);
    if (!cart) return;

    if (confirm(`Switch to "${cart.name}"? Your current cart will be saved.`)) {
      await this.manager.switchCart(cartId);
    }
  }

  showCreateModal() {
    this.currentAction = 'create';
    this.modalTitle.textContent = 'Create New Cart';
    this.modalInput.value = '';
    this.modalInput.placeholder = 'Enter cart name...';
    this.modalConfirm.textContent = 'Create';
    this.modal.classList.add('active');
    this.modalInput.focus();
  }

  showRenameModal(cartId) {
    const cart = this.manager.getCart(cartId);
    if (!cart) return;

    this.currentAction = 'rename';
    this.currentCartId = cartId;
    this.modalTitle.textContent = 'Rename Cart';
    this.modalInput.value = cart.name;
    this.modalInput.placeholder = 'Enter new name...';
    this.modalConfirm.textContent = 'Rename';
    this.modal.classList.add('active');
    this.modalInput.focus();
    this.modalInput.select();
  }

  hideModal() {
    this.modal.classList.remove('active');
    this.currentAction = null;
    this.currentCartId = null;
  }

  async handleModalConfirm() {
    const name = this.modalInput.value.trim();
    if (!name) {
      alert('Please enter a cart name');
      return;
    }

    if (this.currentAction === 'create') {
      await this.manager.createCart(name);
    } else if (this.currentAction === 'rename') {
      this.manager.renameCart(this.currentCartId, name);
    }

    this.hideModal();
    this.renderCarts();
    this.updateCartCount();
  }

  async deleteCart(cartId) {
    const cart = this.manager.getCart(cartId);
    if (!cart) return;

    if (confirm(`Are you sure you want to delete "${cart.name}"?`)) {
      await this.manager.deleteCart(cartId);
      this.renderCarts();
      this.updateCartCount();
    }
  }

  updateCartCount() {
    const carts = this.manager.getAllCarts();
    this.cartCount.textContent = Object.keys(carts).length;
  }
}

// Initialize UI when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    window.multiCartUI = new MultiCartUI();
  });
} else {
  window.multiCartUI = new MultiCartUI();
}